module.exports = __webpack_public_path__ + "img/ilustracao-adote-um-amigo.29eae9e6.png";